import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { setUserInfo } from '../state'; // aktualizuj podle své struktury
const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loggedIn, setLoggedIn] = useState(false);
  const dispatch = useDispatch();
  const userInfo = useSelector((state: any) => state.global.userInfo);

  const login = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/login`, {
      method: 'POST',
      body: JSON.stringify({ email, password }),
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    });

    if (response.ok) {
      const user = await response.json(); // { id, email, role, name }

      dispatch(setUserInfo(user));
      setLoggedIn(true);
    } else {
      const errorMsg = await response.json().catch(() => null);
      alert(errorMsg?.message || 'Wrong credentials ❌');
    }
  };

  // Určit dashboard URL podle role
  const getDashboardUrl = () => {
    // console.log('🔍 getDashboardUrl - userInfo:', userInfo);
    if (!userInfo || !userInfo.id) {
      // console.log('⚠️ userInfo je null/undefined nebo nemá id');
      return '/';
    }
    // console.log('✅ userInfo.role:', userInfo.role, 'userInfo.id:', userInfo.id);

    // Admin má speciální dashboard, všichni ostatní jdou na /client/{userId}
    if (userInfo.role === 'admin') {
      return '/dashboard';
    }

    // Pro role: user, client, webmaster, nebo jakoukoliv jinou -> /client/{userId}
    return `/client/${userInfo.id}`;
  };

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      {/* Debug info - dočasně pro testování */}
      {userInfo && (
        <div
          style={{
            position: 'absolute',
            top: '20px',
            left: '20px',
            padding: '8px',
            backgroundColor: 'rgba(0,0,0,0.05)',
            fontSize: '11px',
            borderRadius: '4px',
            fontFamily: 'monospace',
          }}
        >
          <div>Role: {userInfo.role || 'N/A'}</div>
          <div>ID: {userInfo.id || 'N/A'}</div>
          <div>Email: {userInfo.email || 'N/A'}</div>
        </div>
      )}

      {/* Decentní tlačítko nahoře, pokud je uživatel přihlášený */}
      {userInfo && (
        <div
          style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            zIndex: 1000,
          }}
        >
          <Link
            to={getDashboardUrl()}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 16px',
              backgroundColor: 'rgba(76, 175, 80, 0.1)',
              color: '#4CAF50',
              textDecoration: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              border: '1px solid rgba(76, 175, 80, 0.3)',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(76, 175, 80, 0.2)';
              e.currentTarget.style.borderColor = 'rgba(76, 175, 80, 0.5)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(76, 175, 80, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(76, 175, 80, 0.3)';
            }}
          >
            <span>Dashboard</span>
            <span style={{ fontSize: '12px' }}>→</span>
          </Link>
        </div>
      )}

      <form className="login" onSubmit={login}>
        <h1>Login</h1>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={loggedIn}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={loggedIn}
        />
        <button type="submit" disabled={loggedIn}>
          Login
        </button>

        {loggedIn && userInfo && (
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <p style={{ color: 'green', marginBottom: '15px', fontSize: '16px' }}>
              ✅ Přihlášení úspěšné!
            </p>
            <Link
              to={getDashboardUrl()}
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                backgroundColor: '#4CAF50',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '4px',
                fontSize: '16px',
                fontWeight: 'bold',
              }}
            >
              Přejít na Dashboard →
            </Link>
          </div>
        )}
      </form>
    </div>
  );
};

export default LoginPage;
